import { Badge } from "@/components/ui/badge";
import { AlertOctagon, AlertTriangle, ArrowDown } from "lucide-react";

export const URGENCY_LEVELS = [
  { id: "low", label: "Low", rank: 0 },
  { id: "medium", label: "Medium", rank: 1 },
  { id: "high", label: "High", rank: 2 },
];

export function urgencyRank(u) {
  return URGENCY_LEVELS.find((l) => l.id === u)?.rank ?? 0;
}

export function UrgencyBadge({ urgency }) {
  if (!urgency || urgency === "low") {
    return (
      <Badge
        variant="outline"
        className="text-[10px] font-semibold uppercase tracking-wider border-border text-muted-foreground gap-1"
        data-testid={`urgency-badge-${urgency || "low"}`}
      >
        <ArrowDown strokeWidth={2} className="size-3" />
        Low
      </Badge>
    );
  }
  if (urgency === "medium") {
    return (
      <Badge
        variant="outline"
        className="text-[10px] font-semibold uppercase tracking-wider border-amber-500/40 text-amber-600 dark:text-amber-400 bg-amber-500/10 gap-1"
        data-testid="urgency-badge-medium"
      >
        <AlertTriangle strokeWidth={2} className="size-3" />
        Medium
      </Badge>
    );
  }
  return (
    <Badge
      className="text-[10px] font-semibold uppercase tracking-wider bg-destructive text-destructive-foreground gap-1 border-transparent"
      data-testid="urgency-badge-high"
    >
      <AlertOctagon strokeWidth={2} className="size-3" />
      High
    </Badge>
  );
}

// Sort: incomplete first, then by urgency desc, then by time asc, then by title
export function sortTasks(tasks, doneFn) {
  return [...tasks].sort((a, b) => {
    const da = doneFn(a) ? 1 : 0;
    const db = doneFn(b) ? 1 : 0;
    if (da !== db) return da - db;
    const ur = urgencyRank(b.urgency) - urgencyRank(a.urgency);
    if (ur !== 0) return ur;
    const ta = a.time || "99:99";
    const tb = b.time || "99:99";
    if (ta !== tb) return ta.localeCompare(tb);
    return (a.title || "").localeCompare(b.title || "");
  });
}
